import { h } from 'preact';
import { deviceVariance } from '@cube/blocks';
import { withConfig } from '../../../config';
import { applyCurrent } from '../../configfromcurrent';
import DesktopP25 from './desktop';

const DesktopWithCurrent = applyCurrent()(DesktopP25);

const HeaderP25 = deviceVariance({
	phone: DesktopWithCurrent,
	tablet: DesktopWithCurrent
})(DesktopWithCurrent);

const conf = withConfig([
	'headerWidgetP25.device',
	'headerWidgetP25.theme',
	'headerWidgetP25.useThemeFromWindow',
	'headerWidgetP25.home',
	'headerWidgetP25.current',
	'headerWidgetP25.allowHideNavigation',
	'headerWidgetP25.track'
]);

export default conf(HeaderP25);

// Desktop Header P25 variant
export const DesktopHeaderP25 = conf(DesktopWithCurrent);